/**
 * @generated SignedSource<<7f7ee500e5c8d178cfb4fe509e6ae501>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeWindow = "ONE_DAY" | "SEVEN_DAYS" | "THIRTY_DAYS" | "%future added value";
export type InsightsTabQuery$variables = {
  brandId: string;
  comparisonEndDate: any;
  comparisonStartDate: any;
  endDate: any;
  skipMetricsAggregateWindow?: boolean | null;
  startDate: any;
  timeWindow: TimeWindow;
};
export type InsightsTabQuery$data = {
  readonly brand: {
    readonly comparisonMetrics: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly appOrders: number;
          readonly appSales: number;
          readonly appSessions: number;
          readonly date: any;
          readonly loggedInSessions: number;
          readonly newAppUsers: number;
          readonly orders: number;
          readonly pushEnabledSessions: number;
          readonly sales: number;
        };
      }>;
    };
    readonly currencyCode: string;
    readonly displayName: string;
    readonly metricsAggregate1D: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly appUsers: number;
          readonly date: any;
        };
      }>;
    };
    readonly metricsAggregateWindow?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly appUsers: number;
          readonly date: any;
          readonly id: string;
        };
      }>;
    };
    readonly metricsDaily: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly appOrders: number;
          readonly appSales: number;
          readonly appSessions: number;
          readonly date: any;
          readonly loggedInSessions: number;
          readonly newAppUsers: number;
          readonly orders: number;
          readonly pushEnabledSessions: number;
          readonly sales: number;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"InsightsTabTimeSeries_brand" | "useInsightsTabPlatformBreakdownData_brand">;
  };
};
export type InsightsTabQuery = {
  response: InsightsTabQuery$data;
  variables: InsightsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "brandId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comparisonEndDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comparisonStartDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skipMetricsAggregateWindow"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeWindow"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "brandId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "os",
  "value": {
    "isNull": true
  }
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appUsers",
  "storageKey": null
},
v14 = {
  "condition": "skipMetricsAggregateWindow",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": "metricsAggregateWindow",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "inList.0",
                      "variableName": "endDate"
                    },
                    {
                      "kind": "Variable",
                      "name": "inList.1",
                      "variableName": "comparisonEndDate"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "inList"
                }
              ],
              "kind": "ObjectValue",
              "name": "date"
            },
            (v10/*: any*/),
            {
              "kind": "Variable",
              "name": "timeWindow",
              "variableName": "timeWindow"
            }
          ],
          "kind": "ObjectValue",
          "name": "filters"
        }
      ],
      "concreteType": "GraphQLBrandMetricAggregateConnection",
      "kind": "LinkedField",
      "name": "metricsAggregate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLBrandMetricAggregateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLBrandMetricAggregate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v12/*: any*/),
                (v13/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v15 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "gte",
      "variableName": "startDate"
    },
    {
      "kind": "Variable",
      "name": "lte",
      "variableName": "endDate"
    }
  ],
  "kind": "ObjectValue",
  "name": "date"
},
v16 = [
  {
    "fields": [
      (v15/*: any*/),
      (v10/*: any*/),
      {
        "kind": "Literal",
        "name": "timeWindow",
        "value": "ONE_DAY"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  }
],
v17 = [
  {
    "fields": [
      (v15/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filters"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appOrders",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSales",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSessions",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loggedInSessions",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pushEnabledSessions",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newAppUsers",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orders",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sales",
  "storageKey": null
},
v26 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLBrandMetricDailyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLBrandMetricDaily",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v27 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "gte",
            "variableName": "comparisonStartDate"
          },
          {
            "kind": "Variable",
            "name": "lte",
            "variableName": "comparisonEndDate"
          }
        ],
        "kind": "ObjectValue",
        "name": "date"
      },
      (v10/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filters"
  }
],
v28 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLBrandMetricDailyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLBrandMetricDaily",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InsightsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InsightsTabTimeSeries_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInsightsTabPlatformBreakdownData_brand"
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v14/*: any*/),
          {
            "alias": "metricsAggregate1D",
            "args": (v16/*: any*/),
            "concreteType": "GraphQLBrandMetricAggregateConnection",
            "kind": "LinkedField",
            "name": "metricsAggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLBrandMetricAggregateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLBrandMetricAggregate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": "comparisonMetrics",
            "args": (v27/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "InsightsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": "barchart",
            "args": [
              {
                "fields": [
                  (v15/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "os",
                    "value": {
                      "inList": [
                        "IOS",
                        "ANDROID"
                      ]
                    }
                  }
                ],
                "kind": "ObjectValue",
                "name": "filters"
              }
            ],
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLBrandMetricDailyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLBrandMetricDaily",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "os",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v23/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v14/*: any*/),
          {
            "alias": "metricsAggregate1D",
            "args": (v16/*: any*/),
            "concreteType": "GraphQLBrandMetricAggregateConnection",
            "kind": "LinkedField",
            "name": "metricsAggregate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLBrandMetricAggregateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLBrandMetricAggregate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v17/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": "comparisonMetrics",
            "args": (v27/*: any*/),
            "concreteType": "GraphQLBrandMetricDailyConnection",
            "kind": "LinkedField",
            "name": "metricsDaily",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19ad8c15481c91be9c9efd39d5fc4ad3",
    "id": null,
    "metadata": {},
    "name": "InsightsTabQuery",
    "operationKind": "query",
    "text": "query InsightsTabQuery(\n  $brandId: ID!\n  $timeWindow: TimeWindow!\n  $skipMetricsAggregateWindow: Boolean = false\n  $endDate: Date!\n  $startDate: Date!\n  $comparisonEndDate: Date!\n  $comparisonStartDate: Date!\n) {\n  brand(id: $brandId) {\n    ...InsightsTabTimeSeries_brand\n    ...useInsightsTabPlatformBreakdownData_brand\n    currencyCode\n    displayName\n    metricsAggregateWindow: metricsAggregate(filters: {date: {inList: [$endDate, $comparisonEndDate]}, timeWindow: $timeWindow, os: {isNull: true}}) @skip(if: $skipMetricsAggregateWindow) {\n      edges {\n        node {\n          id\n          date\n          appUsers\n        }\n      }\n    }\n    metricsAggregate1D: metricsAggregate(filters: {date: {lte: $endDate, gte: $startDate}, timeWindow: ONE_DAY, os: {isNull: true}}) {\n      edges {\n        node {\n          date\n          appUsers\n          id\n        }\n      }\n    }\n    metricsDaily(filters: {date: {lte: $endDate, gte: $startDate}, os: {isNull: true}}) {\n      edges {\n        node {\n          date\n          appOrders\n          appSales\n          appSessions\n          loggedInSessions\n          pushEnabledSessions\n          newAppUsers\n          orders\n          sales\n          id\n        }\n      }\n    }\n    comparisonMetrics: metricsDaily(filters: {date: {lte: $comparisonEndDate, gte: $comparisonStartDate}, os: {isNull: true}}) {\n      edges {\n        node {\n          date\n          appOrders\n          appSales\n          appSessions\n          loggedInSessions\n          pushEnabledSessions\n          newAppUsers\n          orders\n          sales\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment InsightsTabTimeSeries_brand on BrandType {\n  currencyCode\n}\n\nfragment useInsightsTabPlatformBreakdownData_brand on BrandType {\n  barchart: metricsDaily(filters: {date: {lte: $endDate, gte: $startDate}, os: {inList: [IOS, ANDROID]}}) {\n    edges {\n      node {\n        date\n        os\n        appSessions\n        newAppUsers\n        appOrders\n        appSales\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dcf7cbc4f90ada80e42941688e6cf3de";

export default node;
